import { useIsMobile } from './useIsMobile'; // your hook from earlier
import { useMemo } from 'react';

export function useResponsiveSize(
  mobileValue = 100,
  desktopValue = 200,
): number {
  const isMobile = useIsMobile();
  // useMemo is optional but can be used to avoid re-calculations on every render
  return useMemo(
    () => (isMobile ? mobileValue : desktopValue),
    [isMobile, mobileValue, desktopValue],
  );
}
